export class MapAutocompleteDTO
{
    Text:string;
    Latitude:number;
    Longitude:number;
    PlaceID :string;
    GoogleMapsURL:string
}